module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CI-455a4f9c5bd26bc4cb8145b0cf1c369f.png";